import React from 'react';
import { Row } from 'reactstrap';
import SearchPartnerIdsToggle from './SearchPartnerIdsToggle';
import SearchPartnerOfferingsToggle from './SearchPartnerOfferingsToggle';
import SearchPracticeActivitiesToggle from './SearchPracticeActivitiesToggle';
import SearchPracticeGroupsToggle from './SearchPracticeGroupsToggle';
import SearchPracticePimsToggle from './SearchPracticePimsToggle';
import ToggleContainer from './ToggleContainer';
import ViewTestPracticesToggle from './ViewTestPracticesToggle';
import ViewDormantPracticesToggle from './ViewDormantPracticesToggle';
import { shallowEqual, useSelector } from 'react-redux';
import hasPermission from '../../../../Shared/hasPermission';

const SearchToggles = () => {
    const permissions = useSelector(
        (state) => state.auth.permissions,
        shallowEqual
    );

    const canViewDormant = hasPermission(['ViewAllPractices'], permissions);

    // TODO: the toggles could be implemented with the factory pattern
    return (
        <Row>
            <ToggleContainer toggle={ViewTestPracticesToggle} />
            {canViewDormant && <ToggleContainer toggle={ViewDormantPracticesToggle} />}
            <ToggleContainer toggle={SearchPartnerIdsToggle} />
            <ToggleContainer toggle={SearchPracticeGroupsToggle} />
            <ToggleContainer toggle={SearchPracticeActivitiesToggle} />
            <ToggleContainer toggle={SearchPartnerOfferingsToggle} />
            <ToggleContainer toggle={SearchPracticePimsToggle} />
        </Row>
    );
};

export default SearchToggles;
